import 'babel-polyfill';
import 'tether/dist/js/tether.min'
import 'jquery';
import 'bootstrap/dist/js/bootstrap.min';

// Styles module
import './scss/main.scss';

import './js/programm-carousel';
import './js/photo-carousel';
import './js/team-carousel';
import './js/scroll-nav';
import './js/modal-content';
import './js/map';
import './js/back-to-top';
import './js/anchor-titles';
import './js/banner-carousel';

// Theme customize
import './js/theme-customization';


// WEBPACK FOOTER //
// ./src/index.js